const DEFAULT_TEXTAREA_SELECTOR = "textarea"

const ChatSubmitClear = {
  mounted() {
    this.form = this.el.matches("form") ? this.el : this.el.querySelector("form")
    this._onSubmit = () => this._clearAfterSubmit()

    if (this.form) {
      this.form.addEventListener("submit", this._onSubmit)
    }

    // The server pushes this when it REFUSES a submit (turn in flight, upload
    // still running, …) so the message the user typed comes back instead of
    // being lost to the submit-time clear. The focused textarea is never
    // value-patched by LiveView, so an assign alone cannot restore it.
    this.handleEvent("restore_composer_input", (payload) => {
      const textarea = this._textarea()
      if (!textarea) return
      if (payload?.id && textarea.id !== payload.id) return

      this._setTextareaValue(textarea, payload?.value || "")
      this._resetTextareaSize(textarea)
    })
  },

  destroyed() {
    if (this.form && this._onSubmit) {
      this.form.removeEventListener("submit", this._onSubmit)
    }
  },

  _clearAfterSubmit() {
    const textarea = this._textarea()
    if (!textarea || textarea.disabled || textarea.value === "") return

    window.setTimeout(() => {
      if (!textarea.isConnected) return

      this._setTextareaValue(textarea, "")
      this._resetTextareaSize(textarea)
      this._clearOverlay()
    }, 0)
  },

  _textarea() {
    const selector = this.el.dataset.chatSubmitClear || DEFAULT_TEXTAREA_SELECTOR

    try {
      return this.form?.querySelector(selector) || this.el.querySelector(selector)
    } catch (_error) {
      return this.form?.querySelector(DEFAULT_TEXTAREA_SELECTOR) ||
        this.el.querySelector(DEFAULT_TEXTAREA_SELECTOR)
    }
  },

  _setTextareaValue(textarea, value) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value")

    if (descriptor?.set) {
      descriptor.set.call(textarea, value)
    } else {
      textarea.value = value
    }
  },

  _resetTextareaSize(textarea) {
    const style = window.getComputedStyle(textarea)
    const maxLines = parseInt(textarea.dataset.maxLines || "1", 10)
    const lineHeight = parseInt(style.lineHeight, 10) || 20
    const paddingTop = parseInt(style.paddingTop, 10) || 0
    const paddingBottom = parseInt(style.paddingBottom, 10) || 0
    const borderTop = parseInt(style.borderTopWidth, 10) || 0
    const borderBottom = parseInt(style.borderBottomWidth, 10) || 0
    const vertical = paddingTop + paddingBottom + borderTop + borderBottom
    const minHeight = lineHeight + vertical
    const maxHeight = Math.max(maxLines, 1) * lineHeight + vertical

    textarea.style.height = "auto"
    textarea.style.height = Math.min(Math.max(textarea.scrollHeight, minHeight), maxHeight) + "px"
    textarea.style.overflowY = "hidden"
    textarea.scrollTop = 0
  },

  _clearOverlay() {
    const selector = this.el.dataset.chatSubmitOverlay
    const overlay = selector ? document.querySelector(selector) : null
    if (!overlay) return

    overlay.innerHTML = ""
    overlay.style.height = ""
    overlay.scrollTop = 0
  },
}

export default ChatSubmitClear
